<template>
<div>
    <pt-sub-title title="医生信息"></pt-sub-title>
    <table class="message-table">
         <pt-message-table-item label="医生姓名">{{data.name}}</pt-message-table-item>
         <pt-message-table-item label="手机号">{{data.mobile}}</pt-message-table-item>
         <pt-message-table-item label="执业医院">
             <table v-if="data.hospitals&&data.hospitals.length" :class="$style['doctor-hospital']">
                 <tr>
                     <td>医院名称</td>
                     <td>分/子公司</td>
                     <td>地区</td>
                 </tr>
                 <tr v-for="(item,index) in data.hospitals" :key="index">
                     <td>{{item.name}}</td>
                     <td>{{item.branchName}}</td>
                     <td>{{item.address}}</td>
                 </tr>
             </table>
         </pt-message-table-item>
         <pt-message-table-item label="职位">{{data.position}}</pt-message-table-item>
         <pt-message-table-item label="所属地区" >{{addressDetails.provinceName+addressDetails.cityName}}</pt-message-table-item>
    </table>
    <div class="message-button-div" >
    <el-button type="primary" @click="getCustomerDetail">用户详情</el-button>
    <el-button type="primary" @click="getDoctorDetail">医生详情</el-button>
    </div>
</div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    userId: String
  },
  computed: {
    addressDetails () {
      return this.data.addressDetails || {}
    }
  },
  methods: {
    getCustomerDetail () {
      this.$router.push(`/all-customer/customer-detail/${this.userId}`)
    },
    getDoctorDetail () {
      this.$router.push(`/doctor-detail/${this.data.id}`)
    }
  }
}
</script>
<style module lang="less">
.doctor-hospital{
    background-color: #FBF8FC;
    padding: 10px 20px;
    :global{
        tr,td{
            border-bottom: 1px solid #D7D4D8
        }
        td{
            min-width: 100px;
            padding: 10px
        }
    }
}
</style>
